<template>
  <div>
    <v-dialog v-model="active" max-width="900" persistent>
      <v-card>
        <v-card-title>Categoría</v-card-title>
        <v-card-text>
          <v-treeview
            :items="modifiedData"
            item-text="name"
            item-key="id"
            v-model="selectItem"
            color="primary"
            @update:open="onOpenTree"
            hoverable
            transition
            rounded
            dense
          >
            <template v-slot:prepend="{ item, open }">
              <v-icon>{{
                item.hasOwnProperty("children") && open
                  ? "mdi-folder-open-outline"
                  : "mdi-folder-outline"
              }}</v-icon>
            </template>
            <template v-slot:label="{ item }">{{ item.name }}</template>
            <template v-slot:append="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon @click="HandlerEdit(item)">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  item.hasOwnProperty("children")
                    ? "Actualizar Tipificación"
                    : "Actualizar Hijo"
                }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    v-if="item.hasOwnProperty('parent_id')"
                  >
                    <v-icon @click="registerChildren(item)">
                      mdi-plus-circle
                      </v-icon>
                  </v-btn>
                </template>
                <span>Agregar Hijo</span>
              </v-tooltip>
              <v-tooltip
                v-if="item.hasOwnProperty('children') == false || item.children == 0"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon @click="HandlerDelete(item)"
                      >mdi-trash-can-outline</v-icon
                    >
                  </v-btn>
                </template>
                <span>{{
                  item.hasOwnProperty("children")
                    ? "Eliminar Tipificación"
                    : "Eliminar Hijo"
                }}</span>
              </v-tooltip>
            </template>
          </v-treeview>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded text @click.stop="cerrar">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <update-component :active="update" :data="UpdateInfo" @dialog:change="eventdialog" />

    <register-children
      :data="editChildren"
      :active="activeChildren"
      :value="value"
      @dialog:change="eventdialog"
      :deepChild="true"
      :parent_id="parentId"
    />
  </div>
</template>

<script>
import UpdateComponent from "../UpdateTypificationsChildren";
import RegisterChildren from "./RegisterChildren";
import { PbxHttpClient } from "@/services/httpclient";
import { nestDeepChild } from "./utils";

export default {
  props: ["active", "data"],
  components: {
    UpdateComponent,
    RegisterChildren,
  },
  data() {
    return {
      selectItem: [],
      update: false,
      name: "",
      value: 0,
      UpdateInfo: {},
      activeChildren: false,
      editChildren: {},
      list: this.data,
      parentId: null,
      openChild: null,
    };
  },

  computed: {
    // This nest the queue_id to every child
    modifiedData() {
      return (
        this.list?.map((parent) => ({
          ...parent,
          children: parent.children.map((child) => ({
            ...child,
            queue_id: parent.queue_id,
            children: child.children ? child.children : [{ name: "loading" }],
          })),
        })) || []
      );
    },
  },

  created() {
    this.list = [...this.data];
  },

  watch: {
    openChild() {
      this.getDeepChildren();
    },
  },
  methods: {
    onOpenTree(item) {
      if (item.length) {
        const id = item.slice(-1)[0];
        if (!this.data.find((el) => el.id === id)) this.openChild = id;
      }
    },
    async getDeepChildren() {
      try {
        const { data } = await PbxHttpClient.post("/clients/typification/show", {
          children_id: this.openChild,
        });
        if (data.data.parent_id !== null) return;
        this.list = nestDeepChild(this.list, data);
      } catch (err) {
        console.log("error", err);
      }
    },
    cerrar() {
      this.$emit("dialog:change", "cerrar");
    },

    registerChildren(item) {
      this.activeChildren = true;
      this.value = 0;
      this.editChildren = {
        queue_id: item.queue_id,
        typification_id: item.id,
        typification_name: item.name,
        name: "",
      };
      this.parentId = item.id;
    },
    HandlerEdit(item) {
      this.update = true;
      this.UpdateInfo = { ...item };
    },
    async HandlerDelete(item) {
      const enviar = {};
      const isChildren =
        Object.prototype.hasOwnProperty.call(item, "typification_id") ||
        Object.prototype.hasOwnProperty.call(item, "parent_id");

      if (isChildren) {
        enviar.children_id = item.id;
      } else {
        enviar.typification_id = item.id;
      }

      try {
        const response = await this.$store.dispatch(
          "typifications/DELETE_TYPIFICATIONS",
          enviar
        );
        this.$emit("dialog:change", response.data.message);
      } catch (err) {
        this.$emit(
          "dialog:change",
          err?.response?.data?.message || "No se puede eliminar"
        );
      }
    },
    eventdialog(message) {
      if (message !== "cerrar") {
        this.$snotify.success(message, "¡Hecho!");
        this.update = false;
        this.$emit("dialog:change", "cerrar");
      }
      this.activeChildren = false;
      this.update = false;
    },
  },
};
</script>

<style></style>
